import React from 'react'
import { NavBarComponent } from "../components/navBar";

class UiHeader extends React.Component {

    static defaultProps = {
        title: "Acuadori Device Dashboard Creator"
    };

    constructor(props) {
        super(props);
        this.handleLogout = this.handleLogout.bind(this);
    }

    handleLogout = () => {
        this.props.logout();
    };

    render() {
        let { isAuthenticated } = this.props;
        return (
            !!isAuthenticated && <NavBarComponent bg={this.props.bg} hidden={!isAuthenticated} callBack={this.handleLogout}></NavBarComponent>
        );
    }
}

export default UiHeader;
